const baseFormat = {
  currencyCode: {
    style: "currency",
    currencyDisplay: "code",
  },
  currencySymbol: {
    style: "currency",
    currencyDisplay: "symbol",
  },
};

export const numberFormats = {
  "en-NG": {
    currencyCode: { ...baseFormat.currencyCode, currency: "NGN" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "NGN" },
  },
  "fr-NG": {
    currencyCode: { ...baseFormat.currencyCode, currency: "NGN" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "NGN" },
  },
  "fr-GH": {
    currencyCode: { ...baseFormat.currencyCode, currency: "GHS" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "GHS" },
  },
  "fr-CI": {
    currencyCode: { ...baseFormat.currencyCode, currency: "XOF" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "XOF" },
  },
  "en-US": {
    currencyCode: { ...baseFormat.currencyCode, currency: "USD" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "USD" },
  },
  "fr-FR": {
    currencyCode: { ...baseFormat.currencyCode, currency: "EUR" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "EUR" },
  },

  "en-FR": {
    currencyCode: { ...baseFormat.currencyCode, currency: "EUR" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "EUR" },
  },
  "ja-JP": {
    currencyCode: { ...baseFormat.currencyCode, currency: "JPY" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "JPY" },
  },
  "en-KE": {
    currencyCode: { ...baseFormat.currencyCode, currency: "KES" },
    currencySymbol: { ...baseFormat.currencySymbol, currency: "KED" },
  },
};
